var isKeyboardEvent = function isKeyboardEvent(event) {
  return event.key !== undefined;
};

export default isKeyboardEvent;